import { Page, Tabs } from '@dixa/lib-shared-habla';
import { Outlet, useLocation } from 'react-router-dom';

import { AppPathWithoutParams } from 'utils/url/appPaths';
import { useAppNavigate } from 'utils/url/useAppNavigate';

const routes = [
  { label: 'Conversation', id: '/settings/custom-attributes/conversation' },
  { label: 'Contact', id: '/settings/custom-attributes/contact' },
];

export const SettingsCustomAttributesView = (): JSX.Element => {
  const location = useLocation();
  const navigate = useAppNavigate();

  const handleTabChange = (path: string) => {
    navigate({
      path: path as AppPathWithoutParams,
    });
  };

  return (
    <Page>
      <Page.Head title="Custom attributes" />

      <Page.Tabs>
        <Tabs
          selectedId={location.pathname}
          tabs={routes}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
